import { createFileRoute } from "@tanstack/react-router";
import { opsHead } from "~/head";
import { UserProfileRoute } from "./index";

export const Route = createFileRoute("/user-profile/{-$suffix}")({
  head: () => opsHead("Profile"),
  component: UserProfileRoute,
});
